[
  {
    "code": "AR-B",
    "name": "Buenos Aires"
  },
  {
    "code": "AR-K",
    "name": "Catamarca"
  },
  {
    "code": "AR-H",
    "name": "Chaco"
  },
  {
    "code": "AR-U",
    "name": "Chubut"
  },
  {
    "code": "AR-C",
    "name": "Ciudad Autónoma de Buenos Aires"
  },
  {
    "code": "AR-W",
    "name": "Corrientes"
  },
  {
    "code": "AR-X",
    "name": "Córdoba"
  },
  {
    "code": "AR-E",
    "name": "Entre Ríos"
  },
  {
    "code": "AR-P",
    "name": "Formosa"
  },
  {
    "code": "AR-Y",
    "name": "Jujuy"
  },
  {
    "code": "AR-L",
    "name": "La Pampa"
  },
  {
    "code": "AR-F",
    "name": "La Rioja"
  },
  {
    "code": "AR-M",
    "name": "Mendoza"
  },
  {
    "code": "AR-N",
    "name": "Misiones"
  },
  {
    "code": "AR-Q",
    "name": "Neuquén"
  },
  {
    "code": "AR-R",
    "name": "Río Negro"
  },
  {
    "code": "AR-A",
    "name": "Salta"
  },
  {
    "code": "AR-J",
    "name": "San Juan"
  },
  {
    "code": "AR-D",
    "name": "San Luis"
  },
  {
    "code": "AR-Z",
    "name": "Santa Cruz"
  },
  {
    "code": "AR-S",
    "name": "Santa Fe"
  },
  {
    "code": "AR-G",
    "name": "Santiago del Estero"
  },
  {
    "code": "AR-V",
    "name": "Tierra del Fuego"
  },
  {
    "code": "AR-T",
    "name": "Tucumán"
  }
]